import spartaBootstrapUtility from "global/sparta-bootstrap-utility";
import jQuery from "vendor/jquery";
import $ from "vendor/jquery";
import _ from "vendor/lodash";
import spartaStoreUtility from "global/sparta-store-utility";
import spartaStyleUtility from "global/sparta-style-utility";
import handlebarsRuntime from "vendor/handlebars-runtime";
import hb from "vendor/handlebars-runtime";
import Module from "global/sparta-module-utility";
import spartaFootnoteUtility from "global/sparta-footnote-utility";
import spartaTemplates from "modules/sales/global-footer-module/4.4.4/js/templates";
import "css!modules/sales/global-footer-module/4.4.4/css/global-footer-module.scss.css";









export default class globalFooterModuleJS extends Module {
  constructor(options) {
    super(options);
  }

  init(args = {}) {

    const defaults = {
      target: '.global-footer-module',
      $target: '',
      $targets: {},
      debug: false,
      var1: 'default',
    };


    const required = {
      data: {
        module: '',
      },
    };


    let settings = {
      ada: {
        openText: ', open',
        closedText: ', closed',
      },
    };

    settings = $.extend({}, settings, defaults, args, required);
    settings.$target = $(settings.target);




    Object.keys(settings.data).forEach((data) => {
      if (settings.$target.data(data)) {
        settings.data[data] = settings.$target.data(data);
      }
    });


    let wrapUrlParam = this.SpartaFunctions.getUrlParam('wrap') || '';
    wrapUrlParam = wrapUrlParam.toUpperCase();
    if (wrapUrlParam === 'MDA') {
      $('#footer_bofa_careers').parents('li').addClass('mda-hide');
    }




    settings.$targets.legalHeader = settings.$target.find('.spa-legal-header');


    settings.$targets.legalHeader
      .on('focus', '.spa-toggle-link', function() {
        $(this).parents('.spa-toggle-heading').addClass('focus');
      }).on('blur', '.spa-toggle-link', function() {
        $(this).parents('.spa-toggle-heading').removeClass('focus');
      }).on('click', function(e) {
        if (e.target === this) {
          $(this).find('.spa-toggle-link').click();
        }
        if ($(this).hasClass('active')) {
          $('#panel-legal').focus();
        }
      });

    const legalViewportConfig = settings.$targets.legalHeader.data('active');
    if (legalViewportConfig && typeof legalViewportConfig === 'object') {
      const vp = legalViewportConfig[spartaStoreUtility.getData('currentMQ.viewport')];
      if (vp) {
        settings.$targets.legalHeader.addClass('active');
      }
    } else if (legalViewportConfig === true) {
      settings.$targets.legalHeader.addClass('active');
    }

    const processAda = (el, text) => {
      if (!el || !text) {
        return;
      }

      $(el).find('.ada-hidden').remove()
        .end()
        .append(`<span class='ada-hidden'>${text}</span>`);
    };





    $('[data-toggle]').each(function() {
      const $content = $($(this).data('toggle'));
      const $dtSpan = $(this).find('> span');


      if ($(this).parents('.spa-toggle-heading').hasClass('active')) {
        $dtSpan.addClass('active');
        processAda(this, settings.ada.openText);
        $content.show();
      } else {
        $dtSpan.removeClass('active');
        processAda(this, settings.ada.closedText);
        $content.hide();
      }

      $(this).on('click', function(e) {
        $dtSpan.toggleClass('active');


        if ($dtSpan.hasClass('active')) {
          $dtSpan.parents('.spa-toggle-heading').addClass('active');
          processAda(this, settings.ada.openText);
        } else {
          $dtSpan.parents('.spa-toggle-heading').removeClass('active');
          processAda(this, settings.ada.closedText);
        }

        $content.stop().slideToggle();
        e.preventDefault();
      });
    });


    $('.footer-breadcrumb-section ol meta').each(function(idx, item) {
      $(item).attr('content', idx + 1);
    });


    $('#footer_bofa_feedback').on('click', function(e) {
      e.preventDefault();

      if (typeof OOo !== "undefined" && typeof OOo.oo_launch === "function") {
        OOo.oo_launch(e, 'oo_feedback');
      }
    });
  }
}
